export const cTipoAsistencia = {
    GENERAL: 1,
    MATERIA: 2
}
